import React from "react";
import Header from "../Header/Header";
import Body from "./Body/Body";

const NotFound = (props) => {
  return (
    <div className="p-8 text-center">
      <Header />
      <Body {...props} />
    </div>
  );
};

export default NotFound;
